import { createContext, useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getSettings } from "@/lib/api";

const SettingsContext = createContext({ settings: null, refresh: () => {} });

export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = async () => {
    try {
      const data = await getSettings();
      setSettings(data);
    } catch (e) {
      setSettings({});
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {settings?.gsc_verification && (
        <Helmet>
          <meta name="google-site-verification" content={settings.gsc_verification} />
        </Helmet>
      )}
      {children}
    </SettingsContext.Provider>
  );
}
